import React, { memo } from 'react'

import { useUnit } from 'effector-react'

import Icon from 'components/_old/Icon/Icon.jsx'
import Link from 'components/_old/Link/Link.jsx'
import { Typo } from 'components/_old/Typo'

import { ItemWithIcon } from 'components/atoms/ItemWithIcon'
import { Typography } from 'components/atoms/Typography'

import { $prevPage } from '../'

const BackLink = memo((): React.ReactElement => {
  const prevPage = useUnit($prevPage)

  return (
    <Link to={prevPage} mods={{ color: 'black' }}>
      <ItemWithIcon
        space={16}
        icon={<Icon type="back-new" size={24} color="inherit" />}
        content={
          <Typography size={16} lineHeight="small" color="inherit">
            <Typo>Back</Typo>
          </Typography>
        }
        iconPosition="center"
        contentVerticalAlign="center"
      />
    </Link>
  )
})
BackLink.displayName = 'BackLink'

export { BackLink }
